<template>
  <div class='comment-modal-container'>
    <div class="header">
      <span class="com">全部评论</span>
      <span class="write">写评论</span>
    </div>
    <div class="content">
      <p class="no-comment"
         v-if="!comments.length">暂无评论</p>
      <!-- 普通留言 -->
      <ul v-infinite-scroll="getComments"
          infinite-scroll-disabled="loadDisabled"
          infinite-scroll-distance="1"
          infinite-scroll-immediate-check=true>
        <li class="item"
            v-for="(item, index) in comments"
            :key="index">
          <div class="commentitem">
            <img :src="item.user.avatar_url">
            <ul class="desc">
              <li class="desc-nickname">
                <span>{{item | nickName}}</span>
                <span class="essence"
                      v-if="item.is_essence">精选</span>
              </li>
              <li @click="getData($event,item, index)"
                  class="desc-content">{{item.content}}</li>
              <div class="replycontent"
                   v-if="item.comment_sub.length">
                <li v-for="son in item.comment_sub.slice(0,5)"
                    @click="getData($event,item,index,son)">
                  <span class="nickname_son">{{son | nickName}}</span>
                  <span v-if="son.to_user"
                        class="replay">&nbsp;回复&nbsp;</span>
                  <!-- <span class="nickname_son">{{item.user && item.user.user_nick}}</span> -->
                  <span v-if="son.to_user"
                        class="nickname_son">{{son.to_user && son.to_user.user_nick}}</span>{{' : '+son.content}}</li>
                <div v-if="item.isShow">
                  <li v-for="son in item.comment_sub.slice(5)"
                      @click="getData($event,item,index,son)">
                    <span class="nickname_son">{{son | nickName}}</span>{{(son.user && son.user.user_nick?' 回复 ':"")}}
                    <span class="nickname_son">{{son | nickName}}</span>{{' : '+son.content}}</li>
                </div>
                <span @click="showAllSub(item)"
                      v-if="item.comment_sub.length > 5"
                      class="is-show">{{item.isShow ?'收起':`全部${item.comment_sub.length}回复`}}
                </span>
                <i :class="item.isShow?'collapse':''"></i>

              </div>
              <li class="desc-time">{{item.create_time}}
                <a class="like"
                   :class="{praise: item.is_like}"
                   @click="sendLike(item, index)">
                  <b v-show="item.like_count>0">{{item.like_count}}</b>
                  <i class="iconfonts"
                     v-if="item.is_like">&#xe602;</i>
                  <i class="iconfonts"
                     v-if="!item.is_like">&#xe601;</i>
                </a>
              </li>
            </ul>

          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import Pubsub from 'pubsub-js'
import { sleep } from '@ivy/fts/utils'
export default {
  props: ["lessonid"],
  data() {
    return {
      loadDisabled: true,
      currentItem: null,
      limit: 10,
      comments: [],
      lastCommentId: '',
      isIndex: -1,
      // 精选留言长度
      essenceLength: 0,
      loading: false
    }
  },
  filters: {
    nickName(item) {
      if (!item || !item.user || !item.user.user_nick) return ''
      return item.user.user_nick
    }
  },
  async  mounted() {
    await this.getComments()
    console.log('----', this.comments)
  },
  methods: {
    async sendLike(item, index) {
      // 点赞实现的接口
      await axios.post('/api/mobile/sns/sns2/like', {
        product_type: 'comment',
        product_id: item.id,
        type: +item.is_like ? 'dislike' : 'like',
      })
      this.comments[index].is_like = !item.is_like
      this.comments[index].like_count += item.is_like ? +1 : -1
    },
    async getComments() {
      if (this.loading) return
      this.loading = true
      let { data: comments } = await this.$axios.get('/api/mobile/sns/sns2/commentList', {
        params: {
          product_type: 'k_course',
          product_id: this.lessonid,
          limit: this.limit,
          offset: this.comments.length,
          includes: 'comment_count,like_count,is_like,comment'
        },
        disableLoading: true
      }, { disableLoading: true })
      this.loading = false
      comments = comments.map(c => ({ ...c, active: false, isShow: false }))
      console.log('comments', comments)
      if (comments.length) {
        this.loadDisabled = false
        this.comments = [...this.comments, ...comments]
      } else {
        this.loadDisabled = true
      }
    },
    async showAllSub(item) {
      item.isShow = !item.isShow
      if (item.comment_sub && item.comment_sub.length > 5) return
      let { data: comments } = await this.$axios.get('/api/mobile/sns/sns2/commentSubList', {
        params: {
          comment_id: item.id,
          limit: 10000,
          offset: 0
        },
        disableLoading: true
      }, { disableLoading: true })
      item.comment_sub = comments
    },
    getData(e, item, index, son = '') {
      // this.togglebgc(e, son.user && son.user.user_nick ? '#f9fae8' : '#fff')
      let currentCommetId = son && son.id || item.id
      let obj = son || item
      if (!this.currentItem || currentCommetId !== this.currentItem.currentCommetId) {
        obj.active = true
      } else if (currentCommetId === this.currentItem.currentCommetId) {
        obj.active = !obj.active
      }
      // 避免使用forEach全部更新
      if (this.currentItem && this.currentItem.index !== index) {
        this.comments[this.currentItem.index].active = false
      }
      this.currentItem = {
        id: obj.id,
        index,
        currentCommetId
      }

      Pubsub.publish('getobj', { ...obj, isRateSon: !!son, comment_id: item.id })
    },
    async togglebgc(e, bgc) {
      let eleStyle = e.currentTarget.style
      eleStyle.backgroundColor = '#efefef'
      await sleep(100)
      eleStyle.backgroundColor = bgc
    },
    async sendObj(obj) {
      this.comments = []
      await this.getComments()
    }
  }
}
</script>

<style lang="less" scoped>
@import url('../../common.less');
.comment-modal-container {
  .header {
    .pad30-lr;
    margin-top: 2.29rem;
    display: flex;
    justify-content: space-between;
    .com {
      font-weight: @boldFontWeight;
      font-size: 0.94rem;
      color: #222;
    }
    .write {
      font-family: PingFangSC-Regular;
      font-size: 0.82rem;
      color: #00b097;
      position: relative;
      &:before {
        content: '';
        position: absolute;
        background: url(../../assets/icons/write-comment.png);
        background-size: cover;
        left: -1.18rem;
        top: 0.15rem;
        width: 0.88rem;
        height: 0.88rem;
      }
    }
  }
  .content {
    .pad30-lr;
    .no-comment {
      padding: 1.18rem 0;
      text-align: center;
      color: @text2;
    }
    .item {
      margin: 1.76rem 0;
      .commentitem {
        position: relative;
        .clearfix;
        img {
          .fl;
          width: 2.65rem;
          height: 2.65rem;
          border-radius: 100%;
        }
        .desc {
          .fl;
          width: 80%;
          margin: 0 0.29rem;
          font-size: 0.88rem;
          font-weight: @lightFontWeight;
          color: #555555;
          position: relative;
          .replycontent {
            padding: 0.53rem;
            background: #f5f6f6;
            border-radius: 0.35rem;
            margin-bottom: 0.88rem;
            font-family: PingFangSC-Light;
            font-size: 0.88rem;
            color: #555555;
            .nickname_son {
              font-family: PingFangSC-Regular;
              font-size: 0.88rem;
              color: #00b097;
            }
            .replay {
              font-family: PingFangSC-Regular;
              font-size: 0.88rem;
              color: #555555;
            }
            .is-show {
              display: inline-block;
              font-family: PingFangSC-Regular;
              font-size: 0.88rem;
              color: #00b097;
              font-size: 0.825rem;
              position: relative;
            }
            i {
              display: inline-block;
              font-style: normal;
              left: 1.8125rem;
              top: 0.325rem;
              width: 0.2375rem;
              height: 0.2375rem;
              border-top: 0.125rem solid #00b097;
              border-right: 0.125rem solid #00b097;
              transform: rotate(135deg);
              transition: all 0.3s linear;
              &.collapse {
                top: 0.325rem;
                transform: rotate(-45deg);
              }
            }
          }
          .desc-nickname {
            font-weight: @boldFontWeight;
            font-size: 0.82rem;
            color: #555555;
            display: flex;
            align-items: center;
            .essence {
              margin-left: 10px;
              font-family: PingFangSC-Regular;
              font-weight: 100;
              font-size: 0.575rem;
              color: #ff875f;
              padding: 0.03rem 0.2rem;
              border: 1px solid #ff875f;
              border-radius: 4px;
            }
          }
          .desc-content {
            word-break: break-all;
            font-family: PingFangSC-Light;
            font-size: 0.88rem;
            color: #555555;
            margin: 0.35rem 0 0.68rem 0;
          }
          .desc-time {
            display: flex;
            align-items: center;
            justify-content: space-between;
            font-family: PingFangSC-Light;
            font-size: 0.71rem;
            color: #999999;
          }
          .desc-reply {
            position: absolute;
            font-size: 0.625rem;
            bottom: 0;
            right: 0.625rem;
          }
        }
        .like {
          display: flex;
          align-items: center;
          color: #979797;
          font-size: 0.71rem;
          b {
            color: #999999;
            font-weight: normal;
            margin-right: 0.53rem;
          }
        }
        .praise {
          color: #fb5d7b;
          b {
            color: #fb5d7b;
            font-weight: normal;
          }
        }
      }
    }
  }
}
</style>
